<template>
  <div class="tab-score" :class="getThemeInfo">
    <!-- 线形进度条 -->
    <!-- <ul class="progress-line-warp">
      <li v-for="item in lineList" :key="item.str">
        <span class="label">{{item.title}}：</span>
        <el-progress :stroke-width="8" :color="item.color" :percentage="item.percentage">
        </el-progress>
      </li>
    </ul> -->
    <!-- 环形进度条 -->
    <div class="progress-circle-warp">
      <!-- 老师评价 -->
      <div class="progress-circle-item "
           v-if="isTeacherRating && judgmentValue(circleList.teacherPercentage)">
        <el-progress class="progress-assembly" type="circle" :show-text="false" :stroke-width='14'
                     :percentage="circleList.teacherPercentage">
        </el-progress>
        <div class="text">
          <div class="score-text">{{circleList.teacherPercentage}}
          </div>
          <div class="person">老师评价</div>
        </div>
      </div>
      <!-- 系统评价 暂时隐藏-->
      <!-- <div class="progress-circle-item " v-if="judgmentValue(circleList.systemPercentage)">
        <el-progress class="progress-assembly" type="circle" :show-text="false" :stroke-width='14'
                     :percentage="circleList.systemPercentage">
        </el-progress>
        <div class="text">
          <div class="score-text">{{circleList.systemPercentage}}</div>
          <div class="person">系统评价</div>
        </div>
      </div> -->
    </div>
    <!-- 分割线 -->
    <div v-if="isTeacherRating" class="dashed-line"></div>
    <!-- 评语 -->
    <div class="comment-warp">
      <div v-if="isTeacherRating" class="editor-warp">
        <span class="label">评语：</span>
        <span v-if="identityType" class="editor-score" @click="scoreVisible=true">修改评价</span>
      </div>
      <div v-if="isTeacherRating" class="comment-warp-content">{{evaluationResults.eval}}</div>
      <div v-if="isTeacherRating" class="evaluate-teachers-warp">
        <span class="label">评价老师：</span>
        <span class="teacher-name">{{evaluationResults.name}}</span>
      </div>
      <div v-if="isTeacherRating" class="evaluate-time-warp">
        <span class="label">评价时间：</span>
        <span class="time-text">{{evaluationResults.evalTime}}</span>
      </div>
    </div>
    <!-- 环形svg -->
    <svg-linear-gradient style="width: 0;height: 0;opacity:0;"></svg-linear-gradient>
    <!-- 评价弹窗 -->
    <score-dialog :dialogVisible="scoreVisible" isEditor title="修改评价"
                  @handleClose="handleScoreClose" @handleConfirm="handleScoreConfirm">
    </score-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { judgmentValue } from '@/utils';
import svgLinearGradient from '@/components/svg-linear-gradient';
import ScoreDialog from '@/components/editor/modules/editorOperation/components/score-dialog';
export default {
  name: 'tabScore',
  components: {
    ScoreDialog,
    svgLinearGradient
  },
  data () {
    return {
      // 线形进度条
      lineList: [
        { title: '准确度', color: '#4F72F5', percentage: 0, str: 'accuracy' },
        { title: '忠实度', color: '#1CDBC7', percentage: 0, str: 'faithful' },
        { title: '流畅度', color: '#FFC115', percentage: 0, str: 'fluent' },
        { title: '完整度', color: '#FF3BB7', percentage: 0, str: 'complete' },
      ],
      // 环形进度条
      circleList: {
        teacherPercentage: 0,
        systemPercentage: 0
      },
      // 控制评价弹窗开关
      scoreVisible: false
    }
  },
  computed: {
    ...mapGetters('editor', [
      'getUrlInfo',                // 路由参数
      'evaluationResults',         // 评价结果
      'getSuggestActiveNameInfo',  // 当前选中的右侧tab
    ]),
    /**
     * @desc 通过主题类型 获取样式类名
     * @returns {string}
     */
    getThemeInfo () {
      let themeInfo = this.$store.getters['editor/getThemeInfo'];
      if (themeInfo === 'dark') {
        return 'score-dark';
      } else if (themeInfo === 'eye-protection') {
        return 'score-eye-protection'
      }
      return ''
    },
    /**
     * @desc 身份是否是老师校领导
     * @return {boolean}
     */
    identityType () {
      let { identityType } = JSON.parse(localStorage.getItem('userInfo'))
      if (!([1, 3].includes(parseInt(identityType)))) {
        return false
      }
      return true
    },
    /**
     * @desc 判断老师是否评价
     * @returns {boolean}
     */
    isTeacherRating () {
      if (this.evaluationResults.scoreStatus) {
        return true
      }
      return false
    },
  },
  watch: {
    evaluationResults: {
      handler () {
        this.installData()
      },
      deep: true
    }
  },
  created () {
    this.judgmentValue = judgmentValue
  },
  mounted () {
    this.$nextTick(() => {
      if (this.getSuggestActiveNameInfo === 'fourth') {
        this.getevaluation()
      }
    })
  },
  methods: {
    ...mapActions('editor', [
      'updateEvaluationResults',
    ]),
    handleScoreClose () {
      this.scoreVisible = false
    },
    handleScoreConfirm () {
      this.scoreVisible = false
    },
    /**
     * @desc 评价结果改变时调用 保证进度条由0到1的过渡效果
     */
    installData () {
      this.lineList.forEach(item => {
        if (this.evaluationResults.hasOwnProperty(item.str)) {
          item.percentage = this.evaluationResults[item.str] ? this.evaluationResults[item.str] : 0
        }
      })
      const { manualScore, avgScore } = this.evaluationResults
      this.circleList.teacherPercentage = manualScore
      this.circleList.systemPercentage = avgScore
    },
    /**
     * @desc 每次进入评价tab都重新获取评价结果
     */
    getevaluation () {
      const { taskId } = this.getUrlInfo
      const params = { taskId }
      this.updateEvaluationResults(params)
    }
  }
}
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>